import React from 'react';
import classnames from 'classnames';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useTranslation } from 'react-i18next';
import s from './WidgetConfigPopover.scss';
const POPOVER_WIDTH = 266;
const POPOVER_HEIGHT_WHEN_LOADING = 166;
const WidgetConfigPopover = ({ height, usePortal = false, withSaveButton = false, saveButtonDisabled, isLoading, shouldCloseOnClickOutside = true, className, onClose, onSave, children })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        wrapperClassName: classnames('no-theme-skin', s['root'], className),
        popoverContent: /*#__PURE__*/ React.createElement(ThemeOverride, {
            tag: "div",
            className: s['theme-override-wrapper'],
            themeSurface: ThemeSurface.TERTIARY
        }, isLoading ? /*#__PURE__*/ React.createElement(LoadingIndicator, {
            coverMode: true
        }) : /*#__PURE__*/ React.createElement(React.Fragment, null, children, withSaveButton && /*#__PURE__*/ React.createElement("div", {
            className: s['footer']
        }, /*#__PURE__*/ React.createElement(BrandedButton, {
            fillContainerWidth: true,
            size: "large",
            variant: "brand-green",
            disabled: saveButtonDisabled,
            onClick: onSave
        }, t('common.save'))))),
        width: POPOVER_WIDTH,
        height: isLoading ? POPOVER_HEIGHT_WHEN_LOADING : height,
        onClickOutside: shouldCloseOnClickOutside ? onClose : undefined,
        className: s['ref-style'],
        contentClassName: s['tooltip-content'],
        placement: "bottom",
        secondaryPlacement: "end",
        usePortal: usePortal
    });
};
WidgetConfigPopover.displayName = 'WidgetConfigPopover';
export default WidgetConfigPopover;
